import gql from 'graphql-tag';

export const GET_PROPOSAL_MENUS_SELECT_OPTIONS = gql`
  query ProposalMenusSelectOptions {
    proposalMenus(input: {}) {
      value: proposalMenuId
      label: name
      modifiedDateTime
    }
  }
`;
